@let dataSourceServiceValue = dataSourceService();

<ng-template
  #groupsDropdown="rtConnectedOverlay"
  rt-connected-overlay
  [hasBackdrop]="true"
  [rtConnectedOverlayAutoClose]="false"
  (backdropClick)="groupsDropdown.open = false"
>
  <rt-dropdown class="groups-dropdown">
    <view-settings-groups
      [layoutControl]="layoutControl"
      [groupControl]="groupControl"
      [defaultGroup]="dataSource().defaultGroup"
      [groups]="dataSource().groups"
      [hasBackButton]="false"
    />
  </rt-dropdown>
</ng-template>

@if (hasControls()) {
  <div class="controls">
    <div
      layout
      layout-space-between
      margin-bottom
      [attr.margin-lr]="viewLayoutType() !== 'list' ? '' : null"
    >
      @if (hasQuickFilters() || hasAdvancedFilters()) {
        <rt-views-quick-filters-container
          [hasAdvancedFilters]="hasAdvancedFilters()"
          [hasClearFilters]="true"
          margin-right-auto
        />
      }

      <rt-views-default-search [searchControl]="searchControl" margin-right-small-x />

      <ng-content select="[after-search]" />

      <rt-group variant="stacked horizontal-manual">
        <rt-view-sort [buttonClass]="controlGroupVisibility().sort.className!" />
        @if (controlGroupVisibility().groups.visible) {
          <rt-icon-button
            #groupsDropdownOrigin="rtOverlayOrigin"
            [pressed]="groupsDropdown.open"
            [active]="!!configIdValue()"
            (click)="groupsDropdown.openAt(groupsDropdownOrigin)"
            variant="tertiary"
            iconName="auto-awesome-motion"
            [class]="controlGroupVisibility().groups.className"
            rt-overlay-origin
          />
        }
        @if (controlGroupVisibility().fields.visible) {
          <view-settings-fields
            #fieldsCmp
            [fieldsControl]="viewForm.controls.layout.controls.fields"
            [layoutControl]="viewForm.controls.layout"
            [templateOnly]="true"
          />

          <ng-template
            #fieldsDropdown="rtConnectedOverlay"
            rt-connected-overlay
            [hasBackdrop]="true"
            [rtConnectedOverlayAutoClose]="false"
            (backdropClick)="fieldsDropdown.open = false"
          >
            <rt-dropdown class="fields-dropdown">
              <ng-template [ngTemplateOutlet]="fieldsCmp.fieldsTmpl()" />
            </rt-dropdown>
          </ng-template>

          <rt-icon-button
            #fieldsDropdownOrigin="rtOverlayOrigin"
            [pressed]="fieldsDropdown.open"
            (click)="fieldsDropdown.openAt(fieldsDropdownOrigin)"
            variant="tertiary"
            iconName="more-horiz"
            [class]="controlGroupVisibility().fields.className"
            rt-overlay-origin
          />
        }
      </rt-group>
      @if (hasLayoutPicker()) {
        <rt-views-view-layout-picker
          [formControl]="viewForm.controls.layout.controls.type"
          [layouts]="availableLayouts()"
          [segmentedControls]="true"
          margin-left-small-x
        />
      }
    </div>
  </div>
}
<ng-content select="[banner]" />
@if (isEmptyStateActive()) {
  <rt-views-empty-state
    [defaultEmptyState]="(dataSourceServiceValue.defaultEmptyState$ | async)!"
    [filteredEmptyState]="(dataSourceServiceValue.filteredEmptyState$ | async)!"
    [isViewPredefined]="isPredefinedView()"
    [filtersChanged]="filtersChanged()"
    [filtersApplied]="filtersApplied()"
    class="data-view--empty-state"
  />
} @else {
  @switch (viewLayoutType()) {
    @case ('table') {
      @defer {
        <rt-views-layout-table
          [selfScrollEnabled]="selfScrollEnabled()"
          [virtualScrollEnabled]="virtualScrollEnabled()"
        />
      }
    }
    @case ('list') {
      @defer {
        <rt-views-layout-list
          [selfScrollEnabled]="selfScrollEnabled()"
          [virtualScrollEnabled]="virtualScrollEnabled()"
        />
      }
    }
    @case ('board') {
      @defer {
        <rt-views-layout-board [cssVars]="layoutBoardCssVars" />
      }
    }
  }
}
